export default (function (value) {
  return value === null;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isNull.js
// module id = 1788
// module chunks = 0